import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { RootState } from 'src/configs/store';
import RetailPage from 'src/containers/Page/RetailPage';
import Button from 'src/components/Button/Button';
import './SecondScreen.scss';

function SecondScreen() {
  const { t } = useTranslation('common');
  const { secondScreen } = useSelector((state: RootState) => state.content);
  const dispatch = useDispatch();

  const changeSecondScreen = (type) => {
    if (localStorage.getItem('fakeTill') === 'true'){
      dispatch.content.changeShowSecondScreen(type);
    }
  };

  return (
    <RetailPage>
      <div className="second-screen">
        {
          _.map(_.orderBy(secondScreen, 'position', 'asc'), (menuItem) => {
            return (
              <Button
                className="btn--primary second-screen__button"
                size="medium"
                onClick={ () => changeSecondScreen(menuItem.title) }
                name={ menuItem.title }
                text={
                  menuItem.shortcut ?
                    `${ menuItem.shortcut.name } ${ t(`secondScreen.${ menuItem.title }`) }` :
                    `${ t(`secondScreen.${ menuItem.title }`) }`
                }
              />
            );
          })
        }
      </div>
    </RetailPage>
  );
}

export default SecondScreen;
